export { AlternatingImageTexts } from "./AlternatingImageTexts"
